import {
  BasicRequest,
  PaginatedBasicRequest,
  StringifyRequest,
} from '@/api/api'
import { PlatformShortcode } from '@/utils/convert-platform'

export enum FetchPostCollectionPostSortBy {
  CreatedAtAsc = 'created_at asc',
  CreatedAtDesc = 'created_at desc',
  PublishedAtAsc = 'published_at asc',
  PublishedAtDesc = 'published_at desc',
  LikeCountAsc = 'like_count asc',
  LikeCountDesc = 'like_count desc',
  CommentCountAsc = 'comment_count asc',
  CommentCountDesc = 'comment_count desc',
  ShareCountAsc = 'share_count asc',
  ShareCountDesc = 'share_count desc',
  WatchCountAsc = 'watch_count asc',
  WatchCountDesc = 'watch_count desc',
  EngagementCountAsc = 'engagement_count asc',
  EngagementCountDesc = 'engagement_count desc',
}

export interface BasicPostCollectionRequest extends BasicRequest {
  id: number
}

export interface BasicPostCollectionPostRequest extends BasicRequest {
  id: number
  post_collection_id: number
}

export interface FetchPostCollectionListRequest
  extends BasicRequest,
    StringifyRequest {
  page: number
  name?: string
  kolUuids?: string[]
  ownerIds?: number[]
  sortBy?: (
    | 'post_amount desc'
    | 'post_amount asc'
    | 'updated_at desc'
    | 'updated_at asc'
  )[]
  collectedPostIds?: string[]
  collectedPlatformType?: number
  reset?: boolean
  perPage?: number
}

export interface ModifyPostCollectionRequest
  extends BasicPostCollectionRequest {
  name: string
}

export type DuplicatePostCollectionRequest = ModifyPostCollectionRequest

export interface DeleteCollectionPostRequest extends BasicRequest {
  collectionId: number
  collectionPostId: number
  postId: string
}

export interface AddCollectionPostRequest extends BasicRequest {
  collectionId: number
  platformType: PlatformShortcode
  postId: string
  uuid: string
}

export interface FetchPostCollectionPostListRequest
  extends Omit<BasicPostCollectionRequest, 'workspaceId'>,
    Omit<PaginatedBasicRequest, 'workspaceId'> {
  platform?: PlatformShortcode
  kol_uuid?: string
  sort_by?: FetchPostCollectionPostSortBy
  title_content_keyword?: string
}
